module.exports = __webpack_public_path__ + "images/cd7d311.png";